export default __webpack_public_path__ + "static/media/black_nightshare.782d8be5.jpg";